var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPearl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.1738C14.4706 18.1738 18.5 14.1444 18.5 9.17383C18.5 4.20327 14.4706 0.173828 9.5 0.173828C4.52944 0.173828 0.5 4.20327 0.5 9.17383C0.5 14.1444 4.52944 18.1738 9.5 18.1738Z",
    fill: "url(#paint0_linear_1_77566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.1738C14.4706 18.1738 18.5 14.1444 18.5 9.17383C18.5 4.20327 14.4706 0.173828 9.5 0.173828C4.52944 0.173828 0.5 4.20327 0.5 9.17383C0.5 14.1444 4.52944 18.1738 9.5 18.1738Z",
    fill: "url(#paint1_radial_1_77566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5027 9.17383C15.4915 12.3738 12.735 15.1255 9.50979 15.1543C6.28417 15.1578 3.55056 12.4062 3.53906 9.17383C3.55056 5.94146 6.28413 3.18985 9.50979 3.19336C12.7351 3.22209 15.4916 5.97384 15.5027 9.17383Z",
    fill: "url(#paint2_linear_1_77566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5865 13.5279C7.32922 13.5474 4.61056 10.8223 4.62525 7.56781C4.63073 6.69966 4.82923 5.87318 5.17573 5.12305C4.17093 6.2015 3.53843 7.62181 3.53906 9.17445C3.55056 12.4068 6.28413 15.1585 9.50979 15.1549C11.8881 15.144 13.987 13.6325 14.9585 11.5856C13.8513 12.7493 12.2957 13.5145 10.5865 13.5279Z",
    fill: "url(#paint3_linear_1_77566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70582 4.62437C8.70695 6.11711 7.49779 7.32739 6.00632 7.33464C4.5152 7.339 3.31514 6.16095 3.35241 4.69627C3.39143 3.23215 4.62049 1.98653 6.07118 1.95183C7.52215 1.91885 8.70231 3.13227 8.70582 4.62437Z",
    fill: "url(#paint4_radial_1_77566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6659 13.6103C15.6186 15.0606 14.3779 16.3079 12.9273 16.3586C11.4763 16.4075 10.3076 15.2076 10.3125 13.7161C10.3199 12.224 11.5312 11.012 13.0227 11.002C14.5138 10.9949 15.7117 12.1595 15.6659 13.6103Z",
    fill: "url(#paint5_radial_1_77566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28231 7.96966C6.27872 9.16093 5.31368 10.124 4.12044 10.1167C2.92763 10.1082 1.95155 9.1565 1.96101 7.99504C1.9711 6.83376 2.9574 5.86458 4.14336 5.84215C5.32968 5.82084 6.28452 6.77857 6.28231 7.96966Z",
    fill: "url(#paint6_radial_1_77566)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_77566",
    x1: 3.13602,
    y1: 15.5377,
    x2: 15.8639,
    y2: 2.80981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_77566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.5 9.17383) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#FF353A",
    stopOpacity: 0.931
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#FF527D",
    stopOpacity: 0.603
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#FF66AD",
    stopOpacity: 0.327
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#FF73CB",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF78D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_77566",
    x1: 3.62776,
    y1: 15.0492,
    x2: 16.5024,
    y2: 2.17464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_77566",
    x1: 5.1816,
    y1: 13.4987,
    x2: 16.0576,
    y2: 2.62266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_77566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.03145 4.64515) scale(2.6858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#FFE9F4",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD1E8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_77566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9961 13.6877) scale(2.67954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#FFE9F4",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD1E8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_77566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.12343 7.9832) scale(2.15019)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#FFE9F4",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD1E8",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC8E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearl);
export default __webpack_public_path__ + "static/media/pearl.ad10fd6cb596f1f0f8c474bd5fe1cb21.svg";
export { ForwardRef as ReactComponent };